import { render, staticRenderFns } from "./Novel_Classification.vue?vue&type=template&id=74f8b689&scoped=true"
import script from "./Novel_Classification.vue?vue&type=script&lang=js"
export * from "./Novel_Classification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f8b689",
  null
  
)

export default component.exports